import React, {useEffect, useState} from "react";
import {Button, Offcanvas} from '../../components/ui';
import useApi from "../../hooks/useApi/useApi";
import {ITemplate} from "../../ModelContracts";
import TemplateCard from "../../components/TemplateCard/TemplateCard";
import {useQuery} from "react-query";
import EmptyList from "../../components/EmptyList/EmptyList";
import ViewTemplate from "../../components/ViewTemplate/ViewTemplate";
import {useSearchParams} from "react-router-dom";
import CreateTemplate from "../../components/CreateTemplate/CreateTemplate";

import './Templates.css';
import '../../styles/SideBar.css';

function Templates() {
	const [searchParams, setSearchParams] = useSearchParams();
	const [templates, setTemplates] = useState([] as ITemplate[]);
	const [templateId, setTemplateId] = useState(searchParams.get('id'));
	const [isCreating, setIsCreating] = useState<boolean>(false);

	const {getTemplates} = useApi();

	useQuery('templates', getTemplates, {
		onSuccess: (templates: ITemplate[]) => {
			setTemplates(templates);
		}
	});

	useEffect(() => {
		setTemplateId(searchParams.get('id'));
	}, [searchParams]);

	const handleCloseTemplate = () => {
		const params = searchParams;
		params.delete('id');
		params.delete('edit');
		setSearchParams(params);
	};

	const handleStartCreating = () => {
		setIsCreating(true);
	};

	const handleStopCreating = () => {
		setIsCreating(false);
	};

	return (
		<div className="w-full px-4">
			<div className="mt-6 mb-2 flex justify-between items-center">
				<h2>Templates</h2>
				<Button onClick={handleStartCreating}>Create Template</Button>
			</div>
			<div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
				{
					templates.map((template : ITemplate) => (
						<TemplateCard key={template.id} template={template} />
					))
				}
				{
					!templates.length && <EmptyList />
				}
			</div>
			<Offcanvas show={Boolean(templateId)}
					   onHide={handleCloseTemplate}
					   placement="end"
					   className="view-template-panel side-bar">
				<Offcanvas.Header className="flex flex-row-reverse" closeButton>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<ViewTemplate id={templateId ?? ''}/>
				</Offcanvas.Body>
			</Offcanvas>
			<Offcanvas show={isCreating}
					   onHide={handleStopCreating}
					   placement="end"
					   className="create-template side-bar"
					   role="dialog"
					   aria-label="Create Template">
				<Offcanvas.Header closeButton>
					<Offcanvas.Title role="heading">Create Template</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<CreateTemplate onCreate={handleStopCreating} />
				</Offcanvas.Body>
			</Offcanvas>
		</div>
	);
}

export default Templates;
